import {
  ChangeDetectionStrategy,
  Component,
  Input,
  TemplateRef,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgIf, NgTemplateOutlet } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Side-avatar component
 */
@Component({
  selector: 'auth-side-avatar',
  templateUrl: './side-avatar.component.html',
  styleUrl: './side-avatar.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [RouterLink, NgIf, NgTemplateOutlet, TranslateModule],
})
export class SideAvatarComponent {
  @Input() customTemplate?: TemplateRef<void>;
}
